import { canAccountBadgeBeReissued, getAccountBadgeValidDistributionStatusChanges, getAccountBadgeValidStatusChanges, } from '../../../../backend/features/badges/shared';
/**
 * Centralized place for all Account Badge action checks
 *
 * For single Account Badge and for multiple (bulk actions)
 */
export function useAccountBadgeActionChecks({ accountBadgesSelected, }) {
    const isSomeValid = accountBadgesSelected.some((ab) => ab.columns.status === 'valid');
    const accountBadgesSelectedWithInfo = accountBadgesSelected.map((ab) => {
        return {
            ab,
            validStatusChanges: getAccountBadgeValidStatusChanges(ab.columns.status),
            validDistributionStatusChanges: getAccountBadgeValidDistributionStatusChanges(ab.columns),
        };
    });
    return {
        canPrint: accountBadgesSelectedWithInfo.some(({ validDistributionStatusChanges }) => {
            return validDistributionStatusChanges.recommended.includes('printed');
        }),
        canNotify: accountBadgesSelected.some((ab) => ab.columns.status === 'valid' && ab.columns.distributionStatus === 'printed'),
        canRevoke: accountBadgesSelectedWithInfo.some(({ validStatusChanges }) => validStatusChanges.includes('revoked')),
        canReissue: accountBadgesSelected.length > 0 && accountBadgesSelected.every((ab) => canAccountBadgeBeReissued(ab).canReissue),
        canEditDistributionStatus: isSomeValid,
        canEditExpirationDate: isSomeValid,
    };
}
